import { defineComponent as _defineComponent } from 'vue'
import { agenda } from '@/store'
import AgendaToolbarExpanded from './AgendaToolbarExpanded.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AgendaToolbar',
  setup(__props) {


return { __sfc: true,agenda, AgendaToolbarExpanded }
}

})